let ctx = null;
let timer = null;
let step = 0;

const SCALE = [523.25, 587.33, 659.25, 783.99, 880.0, 1046.5];
const PATTERN = [0, 2, 4, 5, 4, 2, 3, 5];

function pluck(freq, when, delayNode) {
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = "triangle";
  osc.frequency.value = freq;
  gain.gain.setValueAtTime(0.0001, when);
  gain.gain.exponentialRampToValueAtTime(0.16, when + 0.02);
  gain.gain.exponentialRampToValueAtTime(0.0001, when + 2.2);
  osc.connect(gain);
  gain.connect(ctx.destination);
  gain.connect(delayNode);
  osc.start(when);
  osc.stop(when + 2.4);
}

export function startHarp() {
  if (ctx) {
    ctx.resume();
    return;
  }
  ctx = new (window.AudioContext || window.webkitAudioContext)();

  const delay = ctx.createDelay(1.5);
  delay.delayTime.value = 0.38;
  const feedback = ctx.createGain();
  feedback.gain.value = 0.35;
  const wet = ctx.createGain();
  wet.gain.value = 0.25;
  delay.connect(feedback);
  feedback.connect(delay);
  delay.connect(wet);
  wet.connect(ctx.destination);

  const tick = () => {
    const base = SCALE[PATTERN[step % PATTERN.length]];
    pluck(base, ctx.currentTime + 0.02, delay);
    if (step % 4 === 0) pluck(base * 2, ctx.currentTime + 0.26, delay);
    step += 1;
  };
  tick();
  timer = setInterval(tick, 480);
}

export function stopHarp() {
  if (timer) clearInterval(timer);
  timer = null;
  if (ctx) {
    ctx.close();
    ctx = null;
  }
  step = 0;
}

export function harpRunning() {
  return !!ctx;
}
